import { render, staticRenderFns } from "./Deliverable.vue?vue&type=template&id=a9a024ae&scoped=true"
import script from "./Deliverable.vue?vue&type=script&lang=js"
export * from "./Deliverable.vue?vue&type=script&lang=js"
import style0 from "./Deliverable.vue?vue&type=style&index=0&id=a9a024ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a024ae",
  null
  
)

export default component.exports